import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'
import { persist } from 'zustand/middleware'

const useCommonStore = create(
  persist(
    immer((set) => ({
      sideMenuRefreshKey: 0,
      setSideMenuRefreshKey: (key) => set((state) => { state.sideMenuRefreshKey = key }),
      buttonListAuthority: {},
      setButtonListAuthority: (list) => set((state) => { state.buttonListAuthority = list }),
    })),
    {
      name: 'buttonAuthority',
      getStorage: () => localStorage, 
      // 如果只想持久化部分数据，可以这样写：
      partialize: (state) => ({ buttonListAuthority: state.buttonListAuthority })
    }
  )
)

export default useCommonStore